import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getELearningStudents } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import exportTable from "../../../lib/exportTable";
import { getCommonCodeLabel } from "../../../lib/store";
import { IELearningStudent, IGetELearningStudents } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  res: any;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  semesterCode: number|undefined;
  courseCode: string|undefined;
  learningTypeCode: string|undefined;
  exceptRetire: boolean;
}

const List: FC<IProps> = ({
  res,
  pageNo,
  setPageNo,
  semesterCode,
  courseCode,
  learningTypeCode,
  exceptRetire,
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetELearningStudents>();

  useEffect(() => {
    if (res2 && !isLoading2) {
      const _data: any = _.cloneDeep(res2?.data);
      _data.forEach((item: any) => {
        item.type = item.prdCurriculumFullName?.split('>')[0];
        item.learningTypeCode = getCommonCodeLabel('GR0001', item.learningTypeCode, 'ko');
        item.totalResultScore = item.totalResultScore === null ? '-' : item.totalResultScore;
      });
      const currentDate = moment(new Date());
      exportTable(columns, _data, `${t('statistics.eLearning.title1')}(${t('statistics.homework.tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.homework.tab1')}`, [12, 10, 20, 20, 15, 55, 20, 20, 12, 20, 15, 10, 10]);
    }
  }, [res2, isLoading2]);

  const onExportTable = () => {
    if (!semesterCode) return;

    execute2(getELearningStudents({
      semesterCode,
      courseCode,
      learningTypeCode: learningTypeCode ? [learningTypeCode] : ['PP', 'RV'],
      campusCode: currentCampus,
      exceptRetireYn: exceptRetire ? 'Y' : 'N',
      perPage: 999999999,
      pageNo: 1,
    }));
  }

  const columns: TableColumnsType<IELearningStudent> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      align: 'center',
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      align: 'center',
    },
    {
      title: t('student.student.column64'),
      dataIndex: 'memberCode',
      align: 'center',
    },
    {
      title: t('statistics.eLearning.column1'),
      dataIndex: 'type',
      align: 'center',
      render: (value, record) => record.prdCurriculumFullName?.split('>')[0],
    },
    {
      title: t('statistics.eLearning.1'),
      dataIndex: 'prdCurriculumFullName',
      align: 'center',
      render: value => {
        return (<div className='text-left ant-table-cell-ellipsis'>{value}</div>);
      }
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column3'),
      dataIndex: 'planDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('statistics.dttt.column4'),
      dataIndex: 'completeYn',
      align: 'center',
    },
    {
      title: t('common.column.score'),
      dataIndex: 'totalResultScore',
      align: 'center',
      render: value => (value === null) ? '-' : value
    },
  ];

  return (
    <>
      {isLoading2 && <Loader />}
      <ErrorResponse error={error2} />

      <div className="comm-bx__between">
        <div className="comm-sch_result">
          Total: {<b>{res?.total}</b>}
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>
    </>
  );
}

export default List;
